export const templateData = (type) => {
  if (type == 'issue_by_status') {
    return {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.status.name',
      ['y-axis-field']: 'issues.fields.issue_count',
    };
  }
  if (type == 'issue_by_issuetype') {
    return {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.issuetype.name',
      ['y-axis-field']: 'issues.fields.issue_count',
    };
  }
  if (type == 'issue_by_assignee') {
    return {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.assignee.displayName',
      ['y-axis-field']: 'issues.fields.issue_count',
    };
  }
  if (type == 'issue_by_priority') {
    return {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.priority.name',
      ['y-axis-field']: 'issues.fields.issue_count',
    };
  }
  if (type == 'issue_by_reporter') {
    return {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.reporter.displayName',
      ['y-axis-field']: 'issues.fields.issue_count',
    };
  }
  if (type == 'burn') {
    return {
      template_key: 'jira_burn_down_chart',
      report_type: 'line',
      report_theme: 'dark',
    };
  }
  if (type == 'velocity') {
    return {
      template_key: 'jira_velocity_chart',
      report_type: 'column',
      report_theme: 'dark',
    };
  }
  if (type == 'custom') {
    return {
      template_key: 'custom_report_2',
      report_type: 'column',
      report_theme: 'dark',
      report_name: 'Custom Report',
      filterType: 'Basic Filter',
    };
  }
  if (type == 'list') {
    return {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      listFilterType: 'jql_filter',
    };
  }
};

export const templates = [
  {
    template_key: 'custom_report_2',
    filterType: 'Basic Filter',
    report_type: 'column',
    ['x-axis-field']: 'issues.fields.reporter.displayName',
    ['y-axis-field']: 'issues.fields.issue_count',
    report_name: 'Custom Chart',
  },
  {
    template_key: 'jira_velocity_chart',
    report_type: 'column',
    report_theme: 'dark',
    report_name: 'Velocity Chart',
  },
  {
    template_key: 'jira_burn_down_chart',
    report_type: 'line',
    report_theme: 'dark',
    report_name: 'Burn Down Chart',
  },
  {
    template_key: 'custom_report_2',
    filterType: 'Basic Filter',
    report_type: 'column',
    ['x-axis-field']: 'issues.fields.status.name',
    ['y-axis-field']: 'issues.fields.issue_count',
    report_name: 'Issue by status',
  },
  {
    template_key: 'custom_report_2',
    filterType: 'Basic Filter',
    report_type: 'column',
    ['x-axis-field']: 'issues.fields.issuetype.name',
    ['y-axis-field']: 'issues.fields.issue_count',
    report_name: 'Issue by IssueType',
  },
  {
    template_key: 'custom_report_2',
    filterType: 'Basic Filter',
    report_type: 'column',
    ['x-axis-field']: 'issues.fields.issuetype.name',
    ['y-axis-field']: 'issues.fields.issue_count',
    report_name: 'Issue by assignee',
  },
  {
    template_key: 'custom_report_2',
    filterType: 'Basic Filter',
    report_type: 'column',
    ['x-axis-field']: 'issues.fields.reporter.displayName',
    ['y-axis-field']: 'issues.fields.issue_count',
    report_name: 'Issue by reporter',
  },
  {
    template_key: 'get_issues_by_jql',
    report_type: 'list',
    report_theme: 'dark',
    report_name: 'List Report',
  },
  {
    template_key: 'custom_report_2',
    report_type: 'column',
    report_theme: 'dark',
    report_name: 'Custom Report',
    filterType: 'Basic Filter',
  },
];

export const newTemplateData = [
  {
    isHidden: false,
    _id: '60be0ba493be453c4a572552',
    name: 'Custom Report',
    desc: 'Custom Report',
    logo: 'https://app.troopr.io/logo/Template4.png',
    key: 'custom_report_2',
    app: 'Jira',
    meta: {
      isGraph: true,
      isToken: true,
      x_axis: 'custom',
      x_axis_type: 'custom',
      y_axis: 'custom',
    },
    defaultValues: {
      template_key: 'custom_report_2',
      report_type: 'column',
      report_theme: 'dark',
      report_name: 'Custom Report',
      filterType: 'Basic Filter',
    },
    app_home_supported: true,
  },
  {
    isHidden: false,
    _id: '60be0b0593be453c4a56d80e',
    name: 'BurnDown Chart',
    desc: 'Track the total work remaining and project the likelihood of achieving the sprint goal. This helps your team manage its progress and respond accordingly.',
    logo: 'https://app.troopr.io/logo/troopr-website-burndown-chart.png',
    key: 'jira_burn_down_chart',
    app: 'Jira',
    meta: {
      isToken: true,
      isGraph: true,
    },
    defaultValues: {
      template_key: 'jira_burn_down_chart',
      report_type: 'burn',
      report_theme: 'dark',
      report_name: 'Burn Down Chart',
    },
    position: 1000,
    app_home_supported: true,
  },
  {
    isHidden: false,
    _id: '60be0a2793be453c4a56c71d',
    name: 'Velocity Chart',
    desc: 'Velocity Chart',
    logo: 'https://app.troopr.io/logo/troopr-website-report-velocity.png',
    key: 'jira_velocity_chart',
    app: 'Jira',
    meta: {
      isGraph: true,
      isToken: true,
    },
    defaultValues: {
      template_key: 'jira_velocity_chart',
      report_type: 'velocity',
      report_theme: 'dark',
      report_name: 'Velocity Chart',
    },
    position: 1010,
    app_home_supported: true,
  },
  {
    isHidden: false,
    _id: '60be098e93be453c4a56c5b1',
    name: 'Issues by Status Chart',
    desc: 'Issues by Status Chart',
    logo: 'https://app.troopr.io/logo/troopr-website-report-column-chart.png',
    key: 'jira_count_graph',
    app: 'Jira',
    meta: {
      isGraph: true,
      x_axis: 'fields.status.name',
      isToken: true,
    },
    defaultValues: {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.status.name',
      ['y-axis-field']: 'issues.fields.issue_count',
      report_name: 'Issue by status',
      report_theme: 'dark',
    },
    position: 1020,
    app_home_supported: true,
  },
  {
    isHidden: false,
    _id: '60be099a93be453c4a56c5cb',
    name: 'Issues by Assignee Chart',
    desc: 'Issues by Assignee Chart',
    logo: 'https://app.troopr.io/logo/troopr-website-report-column-chart.png',
    key: 'jira_count_graph',
    app: 'Jira',
    meta: {
      isGraph: true,
      x_axis: 'fields.assignee.displayName',
      isToken: true,
    },
    position: 1030,
    app_home_supported: true,
    defaultValues: {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.assignee.displayName',
      ['y-axis-field']: 'issues.fields.issue_count',
      report_name: 'Issue by assignee',
      report_theme: 'dark',
    },
  },
  {
    isHidden: false,
    _id: '60be09a993be453c4a56c5e0',
    name: ' Issues by Priority Chart',
    desc: ' Issues by Priority Chart',
    logo: 'https://app.troopr.io/logo/troopr-website-report-column-chart.png',
    key: 'jira_count_graph',
    app: 'Jira',
    meta: {
      isGraph: true,
      x_axis: 'fields.priority.name',
      isToken: true,
    },
    position: 1040,
    app_home_supported: true,
    defaultValues: {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.priority.name',
      ['y-axis-field']: 'issues.fields.issue_count',
      report_theme: 'dark',
    },
  },
  {
    isHidden: false,
    _id: '60be0ada93be453c4a56d477',
    name: 'Open issues by Type',
    desc: 'Open issues by Type',
    logo: 'https://app.troopr.io/logo/troopr-website-report-column-chart.png',
    key: 'jira_count_graph',
    app: 'Jira',
    meta: {
      isGraph: true,
      x_axis: 'fields.issuetype.name',
      isToken: true,
    },
    position: 1050,
    app_home_supported: true,
    defaultValues: {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.issuetype.name',
      ['y-axis-field']: 'issues.fields.issue_count',
      report_name: 'Issue by IssueType',
      report_theme: 'dark',
    },
  },
  {
    isHidden: false,
    _id: '60be0b5993be453c4a572464',
    name: 'Issues by Reporter Chart',
    desc: 'Issues by Reporter Chart',
    logo: 'https://app.troopr.io/logo/troopr-website-report-column-chart.png',
    key: 'jira_count_graph',
    app: 'Jira',
    position: 1060,
    meta: {
      isGraph: true,
      x_axis: 'fields.reporter.displayName',
      isToken: true,
    },
    app_home_supported: true,
    defaultValues: {
      template_key: 'custom_report_2',
      filterType: 'Basic Filter',
      report_type: 'column',
      ['x-axis-field']: 'issues.fields.reporter.displayName',
      ['y-axis-field']: 'issues.fields.issue_count',
      report_name: 'Issue by reporter',
      report_theme: 'dark',
    },
  },
  {
    isHidden: false,
    _id: '60be09c493be453c4a56c60d',
    name: 'Estimates too high in a Sprint',
    desc: 'Estimates too high in a Sprint',
    logo: 'https://app.troopr.io/logo/report-template-warning.png',
    key: 'jira_field_count_condition',
    app: 'Jira',
    meta: {
      x_axis: 'fields.timeoriginalestimate',
      condition: '>',
      valueType: 'hours',
      isToken: true,
    },
    position: 1080,
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'Estimates too high in a Sprint',

      select_template_jql: 'resolution=Unresolved',
      listFilterType: 'jql_filter',
    },
  },
  {
    isHidden: false,
    _id: '60be0aea93be453c4a56d5c7',
    name: 'Issues Missing Estimate ',
    desc: 'Issues Missing Estimate',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',

      select_template_jql:
        'resolution=Unresolved AND originalEstimate is EMPTY ORDER BY created DESC',
      listFilterType: 'jql_filter',
    },
    meta: {
      isToken: true,
    },
    position: 1090,
  },
  {
    isHidden: false,
    _id: '60be0a1993be453c4a56c6ff',
    name: 'Issues Ready for QA',
    desc: 'Issues Ready for QA',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql: "status = 'Ready for QA' ORDER BY created DESC",
      listFilterType: 'jql_filter',
    },
    meta: {
      isToken: true,
    },
    position: 1100,
  },
  {
    isHidden: false,
    _id: '60be09f493be453c4a56c6b0',
    name: 'Issues Missing Updates',
    desc: 'Issues Missing Updates',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql: 'resolution=Unresolved',
      listFilterType: 'jql_filter',
      sub_type: 'missing_updates',
    },
    meta: {
      sub_type: 'missing_updates',
      isToken: true,
    },
    position: 1110,
  },
  {
    isHidden: false,
    _id: '60be09da93be453c4a56c644',
    name: 'Issues Progressed Recently',
    desc: 'Issues Progressed Recently',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql: 'status changed during (-1d,now())',
      listFilterType: 'jql_filter',
      sub_type: 'issue_progressed',
    },
    meta: {
      sub_type: 'issue_progressed',
      isToken: true,
    },
    position: 1120,
  },
  {
    isHidden: true,
    _id: '60be09e793be453c4a56c67a',
    name: 'Issues Closed Past Week',
    desc: 'Issues Closed Past Week',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql:
        'resolution != Unresolved AND (status changed to Done after -7d)',
      listFilterType: 'jql_filter',
    },
    meta: {
      isToken: true,
    },
    position: 1130,
  },
  {
    isHidden: true,
    _id: '60be09b693be453c4a56c5f8',
    name: 'Recently Completed Issues',
    desc: 'Recently Completed Issues',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql:
        'resolution != Unresolved AND (status changed to Done after -1d)',
      listFilterType: 'jql_filter',
    },
    meta: {
      isToken: true,
    },
    position: 1160,
  },
  {
    isHidden: false,
    _id: '60be0b8f93be453c4a572507',
    name: 'Recently Closed Issues',
    desc: 'Recently Closed Issues',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql:
        'resolution != Unresolved AND (status changed to Done after -1d)',
      listFilterType: 'jql_filter',
      sub_type: 'closed_issues',
    },
    meta: {
      sub_type: 'closed_issues',
      isToken: true,
    },
    position: 1161,
  },
  //list
  {
    isHidden: false,
    _id: '60be097b93be453c4a56c4ce',
    name: 'Issues by Custom JQL',
    desc: 'Issues by Custom JQL',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    meta: {
      custom_jql: true,
      isToken: true,
    },
    position: 1170,
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      listFilterType: 'jql_filter',
    },
  },
  {
    isHidden: true,
    _id: '60be0b6893be453c4a57247c',
    name: 'Issues Due Today',
    desc: 'Issues Due Today',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql:
        'DueDate >= startOfDay() and DueDate <= endOfDay() And resolution=Unresolved',
      listFilterType: 'jql_filter',
    },
    meta: {
      isToken: true,
    },
    position: 1200,
  },
  {
    isHidden: false,
    _id: '60be0b8093be453c4a5724e3',
    name: 'Issues Due ',
    desc: 'Issues Due ',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      template_key: 'get_issues_by_jql',
      report_type: 'list',
      report_theme: 'dark',
      report_name: 'List Report',
      select_template_jql:
        'DueDate >= startOfDay() and DueDate <= endOfDay() And resolution=Unresolved',
      listFilterType: 'jql_filter',
      sub_type: 'issue_due',
    },
    meta: {
      sub_type: 'issue_due',
      isToken: true,
    },
    position: 1201,
  },
  {
    isHidden: true,
    _id: '60be0b7493be453c4a5724c2',
    name: 'Issues Due Tommorow',
    desc: 'Issues Due Tommorow',
    logo: 'https://app.troopr.io/logo/Template3.png',
    key: 'get_issues_by_jql',
    app: 'Jira',
    defaultValues: {
      select_template_jql:
        'due > now() AND due <= 1d And resolution=Unresolved',
    },
    meta: {
      isToken: true,
    },
    position: 1210,
  },
];
